import React, { useEffect } from "react";
import { fetchDictionaryStart } from "store/dictionary/actions";
import { useDispatch, connect } from "react-redux";
import Select from "react-select";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { withTranslation } from "react-i18next";
import {
  Col,
  Row
} from "reactstrap";
import moment from "moment";
import { toReportDateTimeString } from "common/utils/toReportDateTimeString";

// When `utcDate` is true the picker stays date-only (YYYY-MM-DD) for callers that
// still need a calendar-day boundary.
//
// When `reportTz` is true the picker uses datetime-local and emits the value with
// the UTC+3 broker offset (via the shared toReportDateTimeString helper), matching
// the Reports section contract so the backend filters on the exact UTC+3 instant.
//
// The default (neither flag) keeps the previous datetime-local behaviour (ISO with
// the browser offset) for the other screens that already depend on it.
function FromToDate({ ...props }) {
  let
    {
      filterDate = {
        fromDate: "",
        toDate: ""
      },
      utcDate = false,
      reportTz = false,
    }
      = props;

  const formatToISO = (value) => {
    if (!value) return "";
    return moment(value).format("YYYY-MM-DDTHH:mm:ssZ");
  };

  const formatUtcDate = (value) => {
    if (!value) return "";
    return moment(value).format("YYYY-MM-DD");
  };

  const displayFormat = utcDate ? "YYYY-MM-DD" : "YYYY-MM-DDTHH:mm";
  const toWire = (value) => {
    if (utcDate) return formatUtcDate(value);
    if (reportTz) return toReportDateTimeString(value);
    return formatToISO(value);
  };

  return (
    <React.Fragment>

      <Row>
        <Col className="col-6 mb-3">
          <AvField
            type={utcDate ? "date" : "datetime-local"}
            name="filterDate.fromDate"
            value={
              filterDate?.fromDate
                ? moment(filterDate.fromDate).format(displayFormat)
                : ""
            }
            label={props.t("From")}
            onChange={(e) => {
              props.dateChangeHandler({
                ...filterDate,
                fromDate: toWire(e.target.value)
              });
            }}
          >
          </AvField>
        </Col>
        <Col className="col-6 mb-3">
          <AvField
            type={utcDate ? "date" : "datetime-local"}
            name="filterDate.toDate"
            value={
              filterDate?.toDate
                ? moment(filterDate.toDate).format(displayFormat)
                : ""
            }
            label={props.t("To")}
            onChange={(e) => {
              props.dateChangeHandler({
                ...filterDate,
                toDate: toWire(e.target.value)
              });
            }}
          >
          </AvField>
        </Col>
      </Row>

    </React.Fragment>);
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null)(withTranslation()(FromToDate));
